import styled from 'styled-components';
import { MenuItem as MuiMenuItem } from '@mui/material';

export const MenuItem = styled(MuiMenuItem)`
  font-size: 14px;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 24px;
`;

export const ModalText = styled.p`
  margin: 0;
  font-size: 16px;
`;

export const HelpText = styled.p`
  margin: 16px 0 8px;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;
